import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.node.isRequired
  })
);



// WEBPACK FOOTER //
// ./src/types/BreadcrumbPath.js